import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import {
  delay,
  finalize,
  map,
  mergeMap,
  retryWhen,
  timeout,
} from 'rxjs/operators';
import { AuthService } from './auth.service';
import { EnvService } from './env.service';
import { LoaderService } from './loader.service';
import { UtilService } from './util.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private loader: LoaderService,
    private envService: EnvService,
    private utilService: UtilService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.loader.isLoading.next(true);
    const defaultTimeOut = 60000;

    const isKeycloakUrl =
      req.url.includes('iam.badungkab.dev') ||
      req.url.includes('sso.badungkab.go.id');

    if (!isKeycloakUrl) {
      const user = this.auth.currentUserValue
        ? this.auth.currentUserValue
        : this.auth.userWithPinValue;
      const token = user?.api_token;

      const apiUrl = this.envService.env?.apiUrl;
      const isApiUrl = !!apiUrl && req.url.startsWith(apiUrl);

      const headers: any = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };

      if (user && token && isApiUrl) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      req = req.clone({
        setHeaders: headers,
      });
    }

    return next.handle(req).pipe(
      timeout(defaultTimeOut),
      retryWhen((err$) =>
        err$.pipe(
          mergeMap((error, index) => {
            if (error.status === 401 || error.status === 403) {
              return throwError(() => error);
            }
            if (index >= 1) {
              return throwError(() => error);
            }
            return timer(1000);
          }),
        ),
      ),
      finalize(() => {
        this.loader.isLoading.next(false);
      }),
    );
  }
}
